import React from "react";
import { gql } from "graphql-tag";
import { Link, navigate, RouteComponentProps } from "@reach/router";
import { useMutation, useQuery } from "@apollo/client";
import MaterialTable, { Column } from "@material-table/core";
import { LoadingSpinner } from "components/graphql-views";
import { getFormDefinitions, getFormDefinitions_formDefinitions as FormType, LoadForm, LoadFormVariables } from "types/gql-types";
import { useSnackbar } from "components/haven-design/snackbar";
import { downloadTomlFiles } from "./download-toml";

const columns: Array<Column<FormType>> = [
  { title: "Name", field: "name", render: ({ id, name }) => (<Link to={id}>{name}</Link>) },
  { title: "Safe (not WIP)", field: "enabled", type: "boolean" },
  { title: "Form Showcased", field: "form.display", type: "boolean" },
  { title: "Open", field: "form.open", type: "boolean" },
  { title: "Interest-Creating", field: "createInterest", type: "boolean" },
  { title: "Property", field: "property.name" },
  { title: "Form Type", field: "formType" },
];

const GET_FORMS = gql`
  query getFormDefinitions {
    formDefinitions {
      id
      name
      property { name }
      enabled
      createInterest
      formType
      formId
      form {
        open
        display
      }
    }
  }
`;

export const LOAD_FORM = gql`
  mutation LoadForm($id: ID!) {
    loadFormDefinition(id: $id) {
      id
    }
  }
`;
const downloadTomlFilesAction = {
  icon: "download",
  tooltip: "Download Drafts",
  isFreeAction: true,
  onClick: downloadTomlFiles,
};

const FormDefinitions: React.FC<RouteComponentProps> = () => {
  const { data, error, loading } = useQuery<getFormDefinitions>(GET_FORMS);
  const [loadForm] = useMutation<LoadForm, LoadFormVariables>(LOAD_FORM);

  const { openSnackbar } = useSnackbar();

  if (error) return <span>Server Error</span>;
  if (loading) return <LoadingSpinner />;
  if (!data || !data.formDefinitions) return null;

  return (
    <MaterialTable
      title="Form Drafts"
      style={{ padding: "1.5em" }}
      columns={columns}
      data={data.formDefinitions}
      options={{ pageSize: 20 }}
      actions={[
        {
          icon: "add",
          tooltip: "Add Form Draft",
          isFreeAction: true,
          onClick: () => navigate("../admin/forms/new"),
        },
        {
          ...downloadTomlFilesAction,
          onClick: () => downloadTomlFiles(openSnackbar),
        },
        {
          icon: "info-outlined",
          tooltip: "Details",
          onClick: (_event, rowData) => navigate(`../admin/forms/${(rowData as FormType).id}`),
        },
        {
          icon: "biotech",
          tooltip: "Publish",
          onClick: (_event, rowData) => {
            if (!(rowData as FormType).enabled) {
              openSnackbar({ message: "Publish can be done only for safe forms", status: "error" });
              return;
            }
            loadForm({ variables: { id: (rowData as FormType).id } })
              .then(() => openSnackbar({ message: "Published", status: "success" }));
          },
        },
      ]}
    />
  );
};

export default FormDefinitions;
